import React from 'react';
import logoGrey from '../../assets/imgs/logo_grey.svg';

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-4 text-center">
                        <ul className="list-unstyled">
                            <li><img src={logoGrey} className="img-fluid text-right" style={{height: 25}}/>
                            </li>
                            <li>
                                &copy; 2021. All Rights Reserved
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
}


export default Footer;
